/* eslint-disable no-unused-vars */

import get from "lodash/get";

import aries from "./horoscope/logos/aries.png";
import taurus from "./horoscope/logos/taurus.png";
import gemini from "./horoscope/logos/gemini.png";
import cancer from "./horoscope/logos/cancer.png";
import leo from "./horoscope/logos/leo.png";
import virgo from "./horoscope/logos/virgo.png";
import libra from "./horoscope/logos/libra.png";
import scorpio from "./horoscope/logos/scorpio.png";
import sagittarius from "./horoscope/logos/sagittarius.png";
import capricorn from "./horoscope/logos/capricorn.png";
import aquarius from "./horoscope/logos/aquarius.png";
import pisces from "./horoscope/logos/pisces.png";

const signsMapping = [
  {
    title: "Aries (March 21-April 19)",
    logo: aries
  },
  {
    title: "Taurus (April 20-May 20)",
    logo: taurus
  },
  {
    title: "Gemini (May 21-June 20)",
    logo: gemini
  },
  {
    title: "Cancer (June 21-July 22)",
    logo: cancer
  },
  {
    title: "Leo (July 23-August 22)",
    logo: leo
  },
  {
    title: "Virgo (August 23-September 22)",
    logo: virgo
  },
  {
    title: "Libra (September 23-October 22)",
    logo: libra
  },
  {
    title: "Scorpio (October 23-November 21)",
    logo: scorpio
  },
  {
    title: "Sagittarius (November 22-December 21)",
    logo: sagittarius
  },
  {
    title: "Capricorn (December 22-January 19)",
    logo: capricorn
  },
  {
    title: "Aquarius (January 20-February 18)",
    logo: aquarius
  },
  {
    title: "Pisces (February 19-March 20)",
    logo: pisces
  }
];

export function fetchRelatedStories(story) {
  const sectionId = get(story, ["sections", 0, "id"]);
  return global
    .wretch(`/api/v1/stories/${story.id}/related-stories`)
    .query({
      "section-id": sectionId
    })
    .get()
    .json(response => response["related-stories"]);
}

export default signsMapping;
